<template>
  <Transition
    enter-active-class="transition-[grid-template-rows] duration-300 ease-out"
    enter-from-class="grid-rows-[0fr]"
    enter-to-class="grid-rows-[1fr]"
    leave-active-class="transition-[grid-template-rows] duration-300 ease-out"
    leave-from-class="grid-rows-[1fr]"
    leave-to-class="grid-rows-[0fr]"
  >
    <div v-if="condition" :class="divWrapperClass">
      <div class="min-h-0 overflow-hidden">
        <slot />
      </div>
    </div>
  </Transition>
</template>

<script lang="ts" setup>
defineProps<{
  condition: boolean
  divWrapperClass?: string
}>()
</script>
